import { Validators } from '@angular/forms';

export const ErpControlValidators = [Validators.min(0)];
